import { createResource } from 'react-resource-router';

import { Allowance } from 'src/components/pipelines/models';
import envBaseUrl from 'src/components/pipelines/utils/env-base-url';

import { fetchData } from './utils';

const getUrl = (workspaceSlug: string) =>
  `${envBaseUrl(
    '/!api/internal'
  )}/workspaces/${workspaceSlug}/pipelines-config/allowance`;

export const loadWorkspaceAllowanceResource = createResource({
  type: 'workspace-allowance',
  getKey: ({ match }) => match?.params?.workspaceSlug || 'workspace-allowance',
  maxAge: 60000,
  getData: async ({ match }) => {
    const { workspaceSlug: workspaceSlugParam, repositoryOwner } = match.params;
    const workspaceSlug = repositoryOwner || workspaceSlugParam;

    if (!workspaceSlug) return null;

    const allowance = await fetchData(
      getUrl(workspaceSlug),
      'workspace_allowance_resource_exception'
    );

    return new Allowance({
      isPaid: allowance.is_paid,
      isPremium: allowance.is_premium,
      isPremiumRunner: allowance.is_premium_runners,
      runnerConcurrencyLimit: allowance.runner_concurrency_limit,
    });
  },
});
